import dynamic from 'next/dynamic'

export const ImageGalleryDialog = dynamic(
  () => import('app/components/dialogs/ImageGallery'),
  { ssr: false }
)
